import Swal from 'sweetalert2';

export class GlobalFuntions {
    // * Subrutina  empresaInfo
    empresaInfo(): any {
        const empresaInfo: any = {
            logo        : 'http://172.105.149.128/hedonista/HEDONISTA-FINAL.jpg',
            nombre      : 'HEDONISTA BAR',
            nombreCorto : 'HEDONISTA',
            texto       : 'Estamos en la búsqueda del placer y ¿qué mejor lugar para encontrarlo? Somos un bar de barrio en el corazón de zona 4.',
        };
        return empresaInfo;
    }

    swalError(): any {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Sin servicio',
            returnInputValueOnDeny: false,
        });
    }

    // * Subrutina dateFunction. Retorna hora y/o fecha.
    dateFunction(param): any {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        let date;

        if (month < 10 && day < 10) {
            date = year + '-0' + month + '-0' + day;
        }
        if (month < 10 && day > 10) {
            date = year + '-0' + month + '-' + day;
        }
        if (month > 10 && day > 10) {
            date = year + '-' + month + '-' + day;
        }

        const hour =
            today.getHours() +
            '-' +
            today.getMinutes() +
            '-' +
            today.getSeconds();
        const dateNhour = date + ' ' + hour;
        switch (param) {
            case 'date':
                return date;
            case 'hour':
                return hour;
            case 'dateNhour':
                return dateNhour;
        }
    }
}
